import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class SmsTemplateService extends Service {
	constructor(injector: Injector) {
		super("SmsTemplates", injector);
	}
}